import React from 'react';

interface Props {
  quiz: string;
  theme?: string;
  empha?: string;
  translate?: string;
  result?: 'correct' | 'wrong' | null;
}

function highlightEmpha(text: string, empha?: string) {
  if (!empha || !text.includes(empha)) return <span>{text}</span>;
  const parts = text.split(empha);
  return (
    <>
      {parts.map((part, i) => (
        <React.Fragment key={i}>
          {part}
          {i < parts.length - 1 && <span className="empha">{empha}</span>}
        </React.Fragment>
      ))}
    </>
  );
}

export default function QuestionView({ quiz, theme, empha, translate, result }: Props) {
  return (
    <div className="question-view">
      {theme && (
        <div className="question-theme">{highlightEmpha(theme, empha)}</div>
      )}
      {translate && <div className="question-translate">{translate}</div>}
      <div className="question-text">{quiz}</div>
      {result && (
        <div className={`question-result ${result}`}>
          {result === 'correct' ? '○ 正解' : '✗ 不正解'}
        </div>
      )}
    </div>
  );
}
